export const AppIcons = {
  screenBackground: require("./Background.png"),
  DiceBackground: require("./DiceBack.png"),
  DiceBackground1: require("./DiceBack1.png"),
  HeaderBackground: require("./HeaderBack.png"),
  TokenBackground: require("./TokenBack.png"),
  SelectTokenBackground: require("./SelectPlayerBack.png"),
  Logo: require("./Logo.png"),
  BoardBackground: require("./BoardBack.png"),

  //winner modal
  KingIcon: require("./king.png"),
  Crown: require("./Crown.png"),
  Crown1: require("./Crown1.png"),
  Count: require("./Count.png"),
  CountOther: require("./CountOther.png"),
  PlayAgainBtn:require("./PlayagainBtn.png"),
  ShareBtn:require('./ShareBtn.png'),

  // setting modal
  Cross: require("./Cross.png"),
  Music: require("./Music.png"),
  Notification: require("./Notifi.png"),
  Privacy: require("./Privacy.png"),
  Terms: require("./Terms.png"),
  Volume: require("./Volume.png"),
  Delete: require("./Delete.png"),


  //login
  LoginBack: require("./LoginBack.jpg"),
  BackIcon: require("./BackIcon.png"),
  Apple: require("./Apple.png"),
  Google: require("./Google.png"),

  // board images
  LudoBoard: require("./LudoBoard.png"),
  BlueToken: require("./blue.png"),
  RedToken: require("./red.png"),
  GreenToken: require("./green.png"),
  YellowToken: require("./yallow.png"),

  // home icons
  UserIcon: require("./User.png"),
  SettingsIcon: require("./SettingIcon.png"),
  TickIcon: require("./Tick.png"),
  UnTickIcon: require("./UnTickIcon.png"),

  HomeBtn_1: require("./HomeBtn_1.png"),
  HomeBtn_2: require("./HomeBtn_2.png"),
  HomeBtn_3: require("./HomeBtn_3.png"),
  HomeBtn_4: require("./HomeBtn_4.png"),

  MuteMusic: require("./MuteMusic.png"),
  MusicHome: require("./MusicHome.png"),
  MuteSound: require("./MuteSound.png"),
  SoundHome: require("./SoundHome.png"),

  Plus: require("./Plus.png"),
  Coin: require("./Coin.png"),

  // other
  PlayerBtn: require("./PlayerBtn.png"),
  SelectedPlayerBtn: require("./SelectPlayer.png"),

  // player options
  TwoPlayers: require("./2players.png"),
  ThreePlayers: require("./3players.png"),
  FourPlayers: require("./4players.png"),

  // dice
  Dice: require("./dice.png"),
  Dice_1: require("./dices/Dice_1.png"),
  Dice_2: require("./dices/Dice_2.png"),
  Dice_3: require("./dices/Dice_3.png"),
  Dice_4: require("./dices/Dice_4.png"),
  Dice_5: require("./dices/Dice_5.png"),
  Dice_6: require("./dices/Dice_6.png"),

  // online play
  ActiveBtn: require("./BtnSelect.png"),
  InactiveBtn: require("./BtnDeSelect.png"),
  MicMute: require("./MicMute.png"),
  MicOn: require("./MicOn.png"),
  Speaking: require("./Speaking.png"),
  vsIcon: require("./vs.png"),
  JoinRoom: require("./JoinRoom.png"),
  CreateRoom: require("./CreateRoom.png"),
  CreateRoom1: require("./CreateRoom1.png"),
  JoinRoom1: require("./JoinRoom1.png"),
  OnlineUser: require("./OnlineUser.png"),
  Share: require("./Share.png"),

  //edit profile
  DefProfile: require("./DefProfile.png"),
  Camera: require("./Camera.png"),
  EditIcon: require("./EditIcon.png"),

  //Coin
  CoinBig: require("./CoinBig.png"),
  Coin_1: require("./Coin_1.png"),
  Coin_2: require("./Coin_2.png"),
  Coin_3: require("./Coin_3.png"),
  Coin_4: require("./Coin_4.png"),
  Coin_5: require("./Coin_5.png"),

  // Spin Screen
  Spinbutton: require("./Spinbut.png"),
  Spin: require("./Spin.png"),
  Luck: require("./Luck.png"),
  SpinBackground: require("./SpinBack.png"),
  SpinBackground1: require("./SpinBack1.png"),
  Point: require("./Point.png"),

  // ARROW
  ARROW_UP:require('./Arrow_Up.png')
};
